import React from "react";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { usePlatformTranslation } from "@/hooks/usePlatformTranslation";

export interface ExportButtonProps {
  onClick: () => void;
}

/**
 * Export/Import button component.
 */
export function ExportButton({ onClick }: ExportButtonProps) {
  const { t } = usePlatformTranslation();

  return (
    <Button
      variant="ghost"
      size="sm"
      className="p-2 text-muted-foreground hover:text-foreground hover:bg-muted"
      onClick={onClick}
      title={t('platform.common.import')}
    >
      <Upload className="h-4 w-4" />
    </Button>
  );
}

export default ExportButton;

